import React from 'react';
import {
  Outlet,
  useNavigate,
} from 'react-router-dom';
import PrivateHeader from './PrivateHeader';
import PrivateSidebar from './PrivateSidebar';
import {useSelector} from 'react-redux';

const PrivateLayout = () => {

  const navigate = useNavigate();

  const auth = useSelector(state => state.auth);

  React.useEffect(() => {
    if (auth.authorizingUser === false && auth.tokenExpired === true) {
      if (auth.growerIdOverride !== null && auth.emailAddressOverride !== null) {
        navigate('/?growerId=' + encodeURIComponent(auth.growerId) + '&email=' + encodeURIComponent(auth.emailAddress) +
                 '&growerIdOverride=' + encodeURIComponent(auth.growerIdOverride) + '&emailAddressOverride=' + encodeURIComponent(auth.emailAddressOverride));
      }
      else {
        navigate('/?growerId=' + encodeURIComponent(auth.growerId) + '&email=' + encodeURIComponent(auth.emailAddress));
      }
    }
  }, [auth, navigate]);

  return (
    <>
      <div>
        <PrivateSidebar />
        <div className='wrapper d-flex flex-column min-vh-100'>
          <PrivateHeader />  
          <div className='body flex-grow-1'>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  )
}

export default PrivateLayout;
